



























import OtDocumentList from '@/components/documents/document-list/ot-document-list.vue';
import OtDocumentsFilter from '@/components/documents/document-list/ot-documents-filter.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DocumentListLevel, DocumentListMode, DocumentsFilter } from '@/components/documents/document-models';
import { ContractDetails } from './contract-models';

@Component({
  components: {
    OtDocumentList,
    OtDocumentsFilter,
  },
})
export default class OtContractDocumentsIndex extends Vue {
  // * PROPS
  @Prop() private contractDetails!: ContractDetails;

  // * REFS

  // * COMPUTED
  private get organisationGid() {
    return this.contractDetails.organisationGid;
  }
  private get projectGid() {
    return this.contractDetails.projectGid;
  }
  private get contractGid() {
    return this.contractDetails.gid;
  }
  private get locationDescription() {
    // ENG says this should be something like the contract name, but I'm not so convinced. I guess it could be. We'll see how this feels
    return 'Contract';
    // return this.claimDetails.locationDescription;
  }

  // * DATA
  private filters: DocumentsFilter | null = null;
  private level = DocumentListLevel.Contract;
  private mode = DocumentListMode.Display;

  // * METHODS
  private handleFilterUpdate(nextFilter: DocumentsFilter) {
    this.filters = nextFilter;
  }

  // * LIFECYCLE
}
